import React, { Component } from 'react'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import store from './store'
import style from '@common/ModalIf/style.module.less'
import { SHOP_PRODUCTS_PATH } from '@constant'
import { Link } from 'react-router'
// import UpgradeModal from './UpgradeModal'

@observer
export default class extends Component {
  componentDidMount() {
    store.judgeStatus()
  }
  render() {
    let {
      modalIf: { type, isShow, btn1, btn2, content }
    } = store
    return (
      <HeaderView>
        <div style={{ padding: '160px 0 230px 0', textAlign: 'center' }}>
          <img
            style={{ display: 'inline-block', marginBottom: 15 }}
            src="http://qnm.hunliji.com/o_1bfqpsma2m5627q1nia1kedhn37.png"
          />
          <p style={{ fontSize: 16, color: '#666', lineHeight: '26px' }}>
            如您有多家门店，
          </p>
          <p style={{ fontSize: 16, color: '#666', lineHeight: '26px' }}>
            您可升级至<span style={{ color: '#508cee' }}>多门店模式</span>，来创建并管理更多的门店
          </p>
          <Button
            type="primary"
            style={{ marginTop: 26 }}
            onClick={store.upgradePro}
          >
            升级多门店系统
          </Button>
          {isShow ? (
            <div className={style.tipBox} style={{ zIndex: 999 }}>
              <div className={style.tip2}>
                <div className={style.cont}>{content}</div>
                <div className={style.btnBox}>
                  {type == 1 && (
                    <button onClick={store.onCancel}>{btn1}</button>
                  )}
                  {type == 2 && (
                    <span>
                      <button onClick={store.onCancel}>{btn1}</button>
                      <button>
                        <Link to={SHOP_PRODUCTS_PATH}>{btn2}</Link>
                      </button>
                    </span>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {/*<UpgradeModal />*/}
        </div>
      </HeaderView>
    )
  }
}
